import EdsCreateEDSTheme from '@hedtech/react-design-system/core/es/themes/createEDSTheme';
const createEDSTheme = (baseTheme, overrides) => EdsCreateEDSTheme(baseTheme, overrides);
export default createEDSTheme;
